export const OS=[
    {"name":"Select your choice","Score":0},
    {"name":"windows 7/8/10 64-bit","Score":1},
    {"name":"Linux","Score":2},
    {"name":"Mac","Score":3}
]